import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
/**
 * Composite check that combines multiple checks.
 *
 * Starts and stops all contained checks.
 */
export var ExperienceCheckComposite = /*#__PURE__*/function () {
  function ExperienceCheckComposite(checks) {
    _classCallCheck(this, ExperienceCheckComposite);
    this.checks = checks;
  }
  return _createClass(ExperienceCheckComposite, [{
    key: "start",
    value: function start(callback) {
      this.checks.forEach(function (check) {
        return check.start(callback);
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      this.checks.forEach(function (check) {
        return check.stop();
      });
    }
  }]);
}();